import { render, staticRenderFns } from "./TransferCenterPendingPayments.vue?vue&type=template&id=d2fd4aee&scoped=true"
import script from "./TransferCenterPendingPayments.vue?vue&type=script&lang=js"
export * from "./TransferCenterPendingPayments.vue?vue&type=script&lang=js"
import style0 from "./TransferCenterPendingPayments.vue?vue&type=style&index=0&id=d2fd4aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fd4aee",
  null
  
)

export default component.exports